import React, { Component } from "react"
import { translate } from "react-translate"
import { Segment, Form, Dropdown, Button, Icon } from "semantic-ui-react"

import "./EditionParametrePiedDePageApercu.css"

class EditionParametrePiedDePageApercu extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    let { t } = this.props

    return (
      <Segment id="blocApercuPiedDePage">
        {" "}
        <label id="labelApercuEntete">{t("label_pied")}</label>
        <Segment id="apercuPagePiedDePage">
          <hr id="hrPiedDePage" />
          <p id="textParDefaut">
            abdelbast annomany - 357 Lotissement Assafsaf, Marrakech, 40000
            Marrakech, Maroc
            <br />
            annomanyabdelbast@gmail.com - SARL
          </p>
        </Segment>
      </Segment>
    )
  }
}

export default translate("ProParamFooterApercu")(
  EditionParametrePiedDePageApercu
)



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/PiedDePage/EditionParametrePiedDePageApercu.js